var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.838,
    height: 13.296,
    viewBox: "0 0 16.838 13.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222",
    transform: "translate(-6005.088 -14304.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3221",
    "data-name": "Group 3221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M6015.44,14305.977c-.6-1.024-1.624-.6-2.136-.6",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M6017.235,14312.3l-1.41.855-1.581-.855-3.46,1.129a1.058,1.058,0,0,0-.728,1v2.652h11.538v-2.643a1.059,1.059,0,0,0-.74-1.009Z",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_762",
    "data-name": "Line 762",
    y2: 1.282,
    transform: "translate(6014.415 14311.105)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_763",
    "data-name": "Line 763",
    y1: 1.368,
    transform: "translate(6017.064 14311.105)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M6017.662,14307.088l-1.037.523a1.621,1.621,0,0,1-1.526.021l-1.2-.544-.455.94c0,1.577.284,3.59,2.335,3.59s2.335-2.013,2.335-3.59Z",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M6013.474,14307.943a2.367,2.367,0,0,1-.6-1.709c.256-1.3,1.938-1.668,2.137-1.71a3.075,3.075,0,0,1,1.966.257,2.345,2.345,0,0,1,1.453,1.453,2.3,2.3,0,0,1-.342,1.624",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_764",
    "data-name": "Line 764",
    y2: 2.308,
    transform: "translate(6019.372 14314.78)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_765",
    "data-name": "Line 765",
    y2: 2.308,
    transform: "translate(6012.192 14314.78)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_766",
    "data-name": "Line 766",
    y2: 6.413,
    transform: "translate(6008.295 14306.061)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_767",
    "data-name": "Line 767",
    x1: 6.413,
    transform: "translate(6005.088 14309.268)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 0.665
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.255c50c521eaf8d9d4a50369b94b0575.svg";
export { ForwardRef as ReactComponent };